import { Box } from '@mui/material'
import React from 'react'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import { SisSyncRunDetail } from '../../features/SisSyncRunDetail'

const SisSyncRunDetailPage = (): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <CustomHeader title={PAGE_TITLES.SIS_SYNC_RUN} />
      <SisSyncRunDetail />
    </Box>
  )
}

export default SisSyncRunDetailPage
